import { Role } from '../const';

/**
 * @function convertRole
 * @param { array } roles
 * @param { string } groupId
 * @returns { array }
 */
function convertRole(roles, groupId) {
	const results = roles.map((role) => {
		return {
			[Role.GroupId]: groupId,
			[Role.Id]: role.id,
			[Role.Name]: role.name,
			[Role.Desc]: role.desc,
			[Role.Type]: role.type,
			[Role.Checked]: false,
		};
	});

	return results;
}

export default convertRole;
